<template>
    <div class="search-engine-top-response">
        <div v-if="isShowTasks" class="search-engine-top-response__block">
            <h6 class="search-engine-top-response__title">
                {{ messages?.requests }}
            </h6>
            <div class="search-engine-top-response__products">
                <SearchElement
                    v-for="item in result.tasks"
                    :result="item"
                    :key="item.id"
                />
            </div>
        </div>
        <div v-if="isNpo" class="search-engine-top-response__block">
            <h6 class="search-engine-top-response__title">
                {{ messages?.npo }}
            </h6>
            <div class="search-engine-top-response__products">
                <SearchElement
                    v-for="item in result.npo"
                    :result="item"
                    :key="item.id"
                />
            </div>
        </div>
        <div v-if="getNpoUsers?.length" class="search-engine-top-response__block">
            <h6 class="search-engine-top-response__title">
                {{ messages?.npoUsers }}
            </h6>
            <div class="search-engine-top-response__products">
                <SearchElement
                    v-for="item in getNpoUsers"
                    :result="item"
                    :key="item.id"
                />
            </div>
        </div>
        <div v-if="getVolunteerUsers?.length" class="search-engine-top-response__block">
            <h6 class="search-engine-top-response__title">
                {{ messages?.volunteers }}
            </h6>
            <div class="search-engine-top-response__products">
                <SearchElement
                    v-for="item in getVolunteerUsers"
                    :result="item"
                    :key="item.id"
                />
            </div>
        </div>
        <div v-if="isAreas" class="search-engine-top-response__block">
            <h6 class="search-engine-top-response__title">
                {{ messages?.areas }}
            </h6>
            <div class="search-engine-top-response__products">
                <SearchElement
                    v-for="item in result.areas"
                    :result="item"
                    :key="item.id"
                />
            </div>
        </div>
        <div v-if="isBlog" class="search-engine-top-response__block">
            <h6 class="search-engine-top-response__title">
                {{ messages?.blog }}
            </h6>
            <div class="search-engine-top-response__products">
                <SearchElement
                    v-for="item in result.blog"
                    :result="item"
                    :key="item.id"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchEngineTopResponse',
    props: ['result'],
    computed: {
        isShowTasks() {
            return !!this.result?.tasks?.length;
        },
        isNpo() {
            return !!this.result?.npo?.length;
        },
        isAreas() {
            return !!this.result?.areas?.length;
        },
        isBlog() {
            return !!this.result?.blog?.length;
        },
        getNpoUsers() {
            return this.result?.users?.filter(el => el?.isNpo);
        },
        getVolunteerUsers() {
            return this.result?.users?.filter(el => el?.isVolunteer);
        },
        messages() {
            return this.result?.messages;
        }
    },
}
</script>

<style lang="scss" scoped>
.search-engine-top-response{
    &__title{
        font-size: rem(12);
        margin-bottom: 12px;
        font-weight: rem(500);
        line-height: 120%;
        color: #5F5F67;
    }
    &__block{
        display: flex;
        flex-direction: column;
        margin-bottom: 4px;
    }
    &__sections{
        display: flex;
        flex-direction: column;
    }
    &__section{
        font-size: rem(16);
        line-height: 125%;
        font-weight: 500;
        margin-bottom: 15px;
    }
    &__products{
        display: grid;
        grid-row-gap: 4px;
    }
}
</style>